import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-15803eb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-5 border-bottom text-center" }, "express", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fst-italic border-bottom text-center pb-2 mb-5" }, "Music will define Movement.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fst-italic border-bottom text-center pb-2 mb-5" }, "We are the artists, performers & the performance.", -1))
const _hoisted_5 = { class: "row g-4 pb-5" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "text-secondary" }
const _hoisted_8 = { class: "text-secondary fst-italic" }
const _hoisted_9 = { class: "row mt-5 border-bottom" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "title-number" }
const _hoisted_12 = { class: "title-meta" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col ps-3 text-secondary fw-bold" }
const _hoisted_15 = { style: {"font-size":"30px","padding-left":"30px","font-family":"'Times New Roman',serif"} }
const _hoisted_16 = { class: "row ms-4 ps-2 border-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.songs_, (song, ix) => {
        return (_openBlock(), _createElementBlock("div", {
          key: song.title,
          class: _normalizeClass(["col-6 border-bottom", {'text-end': ix % 2 === 0 }])
        }, [
          _createElementVNode("h4", null, _toDisplayString(ix + 1), 1),
          _createElementVNode("h1", _hoisted_6, _toDisplayString(song.title), 1),
          _createElementVNode("h2", _hoisted_7, _toDisplayString(song.artist), 1),
          _createElementVNode("h3", _hoisted_8, _toDisplayString(song.version), 1)
        ], 2))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.songs, (song, ix) => {
      return (_openBlock(), _createElementBlock("div", {
        key: song.title
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(ix + 1) + ".", 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(song.artist) + " - " + _toDisplayString(song.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(song.stage), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, _toDisplayString(song.desc == "" ? _ctx.desc() : song.desc), 1)
      ]))
    }), 128))
  ]))
}